// "Can't play here" (Figma Shared / Dock / Wall playback card State=Can't play here 4354:29360): this browser cannot
// decode the item (Safari / iOS and an Ogg Vorbis radio). No fallback; the link opens in a new tab.
import { Unlink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { kindOf } from "./registry";
import type { PlayableItem } from "./types";

export default function CantPlayHere({ item }: { item: PlayableItem }) {
  const { t } = useTranslation();
  const kind = kindOf(item);
  const url = kind.playUrl(item);
  const name = item.title || kind.label(t);
  return (
    <div data-testid="player-cant-play" className="flex flex-col items-center gap-2 bg-[var(--bg-base)] p-3 text-center">
      <div className="size-16 shrink-0 rounded-xl bg-[var(--bg-elevated)] text-[var(--foreground-muted)] flex items-center justify-center">
        <Unlink size={28} aria-hidden="true" />
      </div>
      <span role="status" className="text-sm font-bold text-[var(--foreground)]">{t("player_cant_play_here", "Can't play here")}</span>
      <span className="max-w-full break-words text-xs text-[var(--foreground-muted)]">{name}</span>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="player-open-new-tab"
          className="flex h-9 w-full items-center justify-center rounded-full border border-[var(--border-strong)] text-sm font-medium text-[var(--foreground)] hover:bg-[var(--bg-hover)]"
        >
          {t("player_open_in_new_tab", "Open in a new tab")}
        </a>
      )}
    </div>
  );
}
